import { render, staticRenderFns } from "./FormSupport.vue?vue&type=template&id=a8cf3618&scoped=true&"
import script from "./FormSupport.vue?vue&type=script&lang=js&"
export * from "./FormSupport.vue?vue&type=script&lang=js&"
import style0 from "./FormSupport.vue?vue&type=style&index=0&id=a8cf3618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cf3618",
  null
  
)

export default component.exports